import {message} from 'antd';

export const DOWNLOADS_CHANGED_EVENT = 'downloads:changed';

export const notifyDownloadsChanged = () => {
	window.dispatchEvent(new Event(DOWNLOADS_CHANGED_EVENT));
};

// A generating endpoint answered 202: the file will show up on the downloads page.
export const notifyDownloadQueued = (task) => {
	notifyDownloadsChanged();
	message.info(`«${task?.title || 'Файл'}» формируется — он появится во вкладке «Загрузки»`, 5);
};
